var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.333 60.417C106.333 58.0438 106.309 53.2492 106.256 50.8663C105.942 36.0522 105.782 28.6427 100.316 23.1568C94.8493 17.6662 87.2416 17.4777 72.0215 17.0958C62.6753 16.86 53.3247 16.86 43.9785 17.0958C28.7583 17.4777 21.1507 17.6662 15.6842 23.1568C10.2177 28.6427 10.0582 36.0522 9.73915 50.8663C9.6374 55.6218 9.6374 60.3789 9.73915 65.1343C10.0582 79.9485 10.2177 87.358 15.6842 92.8438C21.1507 98.3345 28.7583 98.523 43.9785 98.9048C47.858 99.0015 51.7263 99.0595 55.5833 99.0788",
    stroke: "#C4E1FF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 29L43.0795 47.9708C55.2885 54.897 60.7115 54.897 72.9205 47.9708L104 29M67.6667 84.5833H106.333M67.6667 84.5833C67.6667 81.2 77.3043 74.878 79.75 72.5M67.6667 84.5833C67.6667 87.9667 77.3043 94.2935 79.75 96.6667",
    stroke: "#C4E1FF",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRequestIcon);
export default __webpack_public_path__ + "static/media/newRequestIcon.6bf0cef46ffb1db77326b48d6a9af6f5.svg";
export { ForwardRef as ReactComponent };